import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureConfigService } from '../services/feature-config.service';
import { map, take } from 'rxjs/operators';
import { FeatureTypes } from '../interfaces/feature-config.interface';

export const CanAccessTimelineSimulator: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const featureConfigService = inject(FeatureConfigService);

  return featureConfigService.getFeatureConfigs([FeatureTypes.FEA_CAMPAIGN_TIMELINE]).pipe(
    take(1),
    map((response) => {
      const campaignTimelineConfig = response[FeatureTypes.FEA_CAMPAIGN_TIMELINE];
      const hasSimulator = campaignTimelineConfig?.hasSimulator;

      if (!hasSimulator) {
        router.navigate(['/']);
        return false;
      }

      return true;
    })
  );
};
